export type { FieldConfigs } from './mention-provider';
export { getMentionProvider } from './mention-provider';
